var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('html',[_c('head'),_c('body',[_c('h2',[_vm._v("Instance 和 Server/Regional 的绑定关系")]),_c('p',[_vm._v("每个 Instance 需要和多个 Server 绑定才能提供服务。")]),_c('p',[_vm._v("每个 Instance 要为哪个游戏提供服务，也是由绑定关系决定的。")])])])])
}]

export { render, staticRenderFns }